import { cloneDeep } from 'lodash';
import { PROJECTS_TAG, TRANSFORMATIONS_TAG } from '../../../../data/actions';

const NODE_OPERATIONS_TAG = 'NodeOperations';

export const DATA_EXTRACTION_DATA_TREES = 'DATA_EXTRACTION_DATA_TREES';
export const PROJECT_TRANSFORMATIONS = 'PROJECT_TRANSFORMATIONS';

const setDataTrees = dataTrees => {
  return {
    type: DATA_EXTRACTION_DATA_TREES,
    dataTrees
  };
};

const setProjectTransformations = projectTransformations => {
  return {
    type: PROJECT_TRANSFORMATIONS,
    projectTransformations
  };
};

export const createDataNodeOperation = (type, dataNodeId) => {
  const operationIds = {
    validation: 'createNodeValidation',
    parsing: 'createNodeParsing',
    sync: 'createNodeSync',
    baseline: 'createNodeBaseline'
  };

  const operationId = operationIds[type];

  return async (dispatch, getState, { apiClient }) => {
    await apiClient.call(NODE_OPERATIONS_TAG, operationId, null, { data_tree_node_id: dataNodeId });
  };
};

export const updateDataNodeOperation = ({ dataTreeRootId, dataTreeNodeId, type, data }) => {
  return (dispatch, getState) => {
    const newDataTree = getState().projects.single.fileImport.dataTrees.map(dataTreeRoot => {
      let outputDataTreeRoot = dataTreeRoot;
      if (dataTreeRoot.id === dataTreeRootId) {
        outputDataTreeRoot = cloneDeep(dataTreeRoot);
        outputDataTreeRoot.data_tree_nodes = outputDataTreeRoot.data_tree_nodes.map(dataTreeNode => {
            if (dataTreeNode.id === dataTreeNodeId) {
              dataTreeNode[type] = data;
            }
            return dataTreeNode;
          }
        );
      }
      return outputDataTreeRoot;
    });
    dispatch(setDataTrees(newDataTree));
  };
};

export const fetchProjectDataTrees = projectId => {
  return async (dispatch, getState, { apiClient }) => {
    const results = await apiClient.call(PROJECTS_TAG, 'getProjectDataTrees', { projectId });

    dispatch(setDataTrees(results.data));
  };
};

export const fetchTransformations = () => {
  return async (dispatch, getState, { apiClient }) => {
    const results = await apiClient.call(TRANSFORMATIONS_TAG, 'getTransformations');

    dispatch(setProjectTransformations(results.data));
    return true;
  };
};


// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/data/fileImport/dataTreesActions.js